"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2544],{

/***/ 92544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pro_tools_Chartbit; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/LandingPage/index.ts + 8 modules
var LandingPage = __webpack_require__(55781);
// EXTERNAL MODULE: ./src/features/pro-tools/constants.ts
var constants = __webpack_require__(23443);
;// CONCATENATED MODULE: ./src/features/pro-tools/Chartbit/content.ts
var chartbitContents = [
    {
        title: "15 Tahun Price History",
        description: "Lihat tren harga saham sampai dengan 15 tahun kebelakang untuk menganalisa tren jangka panjang.",
        image: "Chartbit_15_Years_Blue.jpg"
    },
    {
        title: "Bandarmologi",
        description: "Deteksi dan pelajari gerak bandar, jadilah teman bandar untuk membantu kamu mendapatkan keuntungan. Gunakan indikator bandarmologi untuk mempelajari akumulasi dan distribusi para bandar.",
        image: "Chartbit_Bandarmology_Blue.jpg"
    },
    {
        title: "Corporate Action Event",
        description: "Pantau pergerakan harga pada saat ex date dari aksi korporasi yang dilakukan seperti pembagian dividen, stock split atau right issue.",
        image: "Chartbit_Corp_Event_Blue.jpg"
    },
    {
        title: "100+ Technical Indikator",
        description: "Tersedia ratusan indikator siap pakai untuk mempertajam analisa teknikal Anda. Mulai dari indikator dasar seperti Moving Average, MACD, RSI sampai indikator khusus dari Stockbit seperti Bandar Value dan Foreign Flow.",
        image: "Chartbit_Indicator_Blue.jpg"
    },
    {
        title: "Foreign Flow",
        description: "Pantau pergerakan dana asing di saham pilihanmu, apakah net inflow atau outflow. Pelajari juga seberapa kuat transaksi dana asing pada saham tersebut.",
        image: "Chartbit_Foreign_Blue.jpg"
    }, 
];
var additionalInfos = [
    {
        title: "Real-time Price",
        description: "Data price di chartbit merupakan data terkini dari harga di pasar. Data price akan berubah dengan sendirinya jika ada perubahan data di pasar karena Chartbit terintegrasi langsung dengan server IDX."
    },
    {
        title: "Intraday Price Interval",
        description: "Selain periode daily, weekly dan monthly. Kamu juga bisa memilih periode chartbit mulai dari 1 menit, 5 menit, 30 menit, sampai 1 jam."
    }, 
];


// EXTERNAL MODULE: ./src/features/pro-tools/styled.ts
var styled = __webpack_require__(12957);
;// CONCATENATED MODULE: ./src/features/pro-tools/Chartbit/index.tsx





function Chartbit() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPage/* PageHeader */.mr, {
                title: "Chartbit",
                description: "Charting tools modern dan canggih dengan ratusan indikator untuk menganalisa dan memprediksi harga saham"
            }),
            chartbitContents.map(function(content, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPage/* SectionBrowser */.Dr, {
                    title: content.title,
                    image: "".concat(constants/* ASSET_URL */.Z).concat(content.image),
                    description: content.description,
                    reverse: index % 2 === 0
                });
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* AdditionalWrapper */.xj, {
                children: additionalInfos.map(function(info) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Title */.Dx, {
                                children: info.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Description */.dk, {
                                children: info.description
                            })
                        ]
                    });
                })
            })
        ]
    });
}
/* harmony default export */ var pro_tools_Chartbit = (Chartbit);


/***/ }),

/***/ 12957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "Gh": function() { return /* binding */ HeaderTitle; },
/* harmony export */   "Pz": function() { return /* binding */ HeaderWrapper; },
/* harmony export */   "R3": function() { return /* binding */ ButtonInvest; },
/* harmony export */   "dk": function() { return /* binding */ Description; },
/* harmony export */   "xj": function() { return /* binding */ AdditionalWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-gap: 50px;\n  margin: auto;\n  padding: 0 25px;\n  width: 100%;\n  max-width: 940px;\n\n  @media ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap: 100px;\n    padding: 0;\n    width: calc(100% - 151px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  margin: auto;\n  margin-bottom: 20px;\n\n  @media ",
        " {\n    text-align: left;\n    margin: unset;\n    margin-bottom: 20px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n  margin: auto;\n  text-align: center;\n\n  @media ",
        " {\n    margin: unset;\n    text-align: left;\n  }\n\n  @media ",
        " {\n    font-size: 18px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  flex-direction: column;\n  margin: 100px auto;\n  padding: 50px 25px;\n  width: 100%;\n  max-width: 1300px;\n\n  .title-wrapper,\n  .illustration {\n    width: 100%;\n  }\n\n  .title-wrapper {\n    margin-bottom: 70px;\n  }\n\n  @media ",
        " {\n    padding: 50px 30px;\n  }\n\n  @media ",
        " {\n    flex-direction: row;\n    margin: 130px auto;\n    padding: 50px 0;\n    width: calc(100% - 151px);\n\n    .title-wrapper,\n    .illustration {\n      margin-bottom: 0;\n    }\n\n    .title-wrapper {\n      width: 40%;\n      padding-right: 50px;\n    }\n    .illustration {\n      width: 60%;\n      padding-left: 50px;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border-radius: 4px;\n  color: ",
        ";\n  cursor: pointer;\n  font-family: var(--bold-font);\n  font-size: 18px;\n  height: 50px;\n  margin: auto;\n  margin-bottom: 50px;\n  padding: 0 20px;\n  text-transform: uppercase;\n  width: fit-content;\n  max-width: 100%;\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  @media ",
        " {\n    margin: 0;\n    margin-bottom: 9vh;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 30px;\n  margin: auto;\n  margin-bottom: 20px;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 60px;\n    margin-bottom: 60px;\n  }\n\n  @media ",
        " {\n    margin: 0;\n    margin-bottom: 60px;\n    text-align: left;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex;
var AdditionalWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-f0d3870b-0"
})(_templateObject(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).attrs({
    as: "h2",
    size: "40px",
    family: "bold"
}).withConfig({
    componentId: "sc-f0d3870b-1"
})(_templateObject1(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var Description = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).attrs({
    height: 1.3,
    color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.dimgray */ .$_.dimgray
}).withConfig({
    componentId: "sc-f0d3870b-2"
})(_templateObject2(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.laptop */ .Uh.laptop);
var HeaderWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).withConfig({
    componentId: "sc-f0d3870b-3"
})(_templateObject3(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.laptop */ .Uh.laptop);
var ButtonInvest = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    as: "a",
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-f0d3870b-4"
})(_templateObject4(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.laptop */ .Uh.laptop);
var HeaderTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).attrs({
    as: "h1",
    family: "bold",
    height: 1.3
}).withConfig({
    componentId: "sc-f0d3870b-5"
})(_templateObject5(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.laptop */ .Uh.laptop);



/***/ })

}]);